import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";

// CREATE DEPARTMENT (SPECIALITY)
export const createDepartment = createAsyncThunk("department/create", async (departmentData, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post("/api/v1/cc/department", departmentData, {});
    return response.data;
  } catch (error) {
    console.error("Error creating department:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating department";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// GET ALL DEPARTMENT (SPECIALITYY)
export const getAllDepartments = createAsyncThunk("department/getAll", async ({ page, limit, sort, searchFields, search, fields }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get("/api/v1/cc/department", {
      params: {
        page,
        limit,
        sort,
        searchFields,
        search,
        fields,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in getting department:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "upexpected error";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
// GET ALL DEPARTMENT without loading screen (SPECIALITYY)
export const getDepartmentSuggestion = createAsyncThunk("department/getSuggestion", async ({ page, limit, sort, searchFields, search }) => {
  try {
    const response = await api.get("/api/v1/cc/department", {
      params: {
        page,
        limit,
        sort,
        searchFields,
        search,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in getting department:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error in getting department";
    throw new Error(errorMessage);
  }
});

// UPDATE DEPARTMENT (SPECIALITY)
export const updateDepartment = createAsyncThunk("department/update", async ({ departmentId, updatedData }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/department/${departmentId}`, updatedData, {});
    return response.data;
  } catch (error) {
    console.error("Error in updating department:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error in updating department";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// TOGGLE ACTIVATE DEPARTMENT (SPECIALITY)
export const toggleActiveDepartment = createAsyncThunk("department/toggleActive", async (departmentId, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.delete(`/api/v1/cc/department/${departmentId}`);
    return response.data;
  } catch (error) {
    console.error("Error in updating department:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error in updating department";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// ADD OR UPDATE DEPARTMENT PRICE
export const updateDepartmentPrice = createAsyncThunk("department/updateDepartmentPrice", async (body, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`api/v1/cc/department/price`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error in updating department price:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error in updating department price";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// get all DEPARTMENT PRICE
export const getAllDepPrice = createAsyncThunk("department/getAllDepPrice", async ({ page, limit, search, searchFields }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      sort: "priceCode",
      search,
      searchFields: searchFields,
    };
    const response = await api.get(`/api/v1/cc/department/price`, { params });
    return response.data;
  } catch (error) {
    console.error("Error in getting department price:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error in getting department price";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// delete DEPARTMENT PRICE
export const deleteDepPrice = createAsyncThunk("department/deleteDepPrice", async ({ priceCode }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      priceCode,
    };
    const response = await api.delete(`api/v1/cc/department/price`, { params });
    return response.data;
  } catch (error) {
    console.error("Error in deleting department price:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error in deleting department price";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
